import "./SiteFooter.scss";
import PropTypes from "prop-types";
import jlrLogoUrl from "../../assets/imgs/home/JLR.svg";
import PoweredByConstellation from "./PoweredByConstellation";

const JLR_LOGOS = [{ src: jlrLogoUrl, alt: "JLR", width: 44, height: 40 }];

/** Brand logo(s) + "Powered and administered by Constellation", with optional legal copy below. */
function SiteFooter({ dark = false, logos = JLR_LOGOS, className = "", children }) {
	return (
		<footer
			className={`site-footer${dark ? " site-footer--dark" : ""} ${className}`.trim()}>
			<div className="site-footer__inner global-padding">
				<div className="site-footer__brands">
					<div className="site-footer__logos">
						{logos.map((logo) => (
							<img
								key={logo.alt}
								src={logo.src}
								alt={logo.alt}
								className="site-footer__logo"
								width={logo.width}
								height={logo.height}
							/>
						))}
					</div>
					<PoweredByConstellation />
				</div>
				{children && <div className="site-footer__legal">{children}</div>}
			</div>
		</footer>
	);
}

SiteFooter.propTypes = {
	dark: PropTypes.bool,
	logos: PropTypes.arrayOf(
		PropTypes.shape({
			src: PropTypes.string.isRequired,
			alt: PropTypes.string.isRequired,
			width: PropTypes.number,
			height: PropTypes.number,
		}),
	),
	className: PropTypes.string,
	children: PropTypes.node,
};

export default SiteFooter;
